/**
 * Traduction française des libellés de catégories de la place de marché source.
 *
 * Les clés sont les segments exacts de la taxonomie source, avec leur casse et leur ponctuation
 * d'origine (« Home & Living », « Women's Clothing »). Un chemin complet
 * (« Home & Living > Floor & Rugs > Rugs ») se traduit segment par segment.
 *
 * Tout segment absent de ce dictionnaire s'affiche tel quel, en anglais.
 *
 * Clés classées dans l'ordre alphabétique de la base (espaces et ponctuation ignorés).
 */
export const CATEGORIES_FR: Readonly<Record<string, string>> = {
  'Accent Lamps': "Lampes d'appoint",
  Accessories: 'Accessoires',
  Acrylic: 'Acrylique',
  'Address Signs': "Plaques d'adresse",
  'Aisle Runners & Decor': "Chemins d'allée et décoration",
  Anklets: 'Chaînes de cheville',
  'Appliance Decals': 'Stickers pour électroménager',
  'Art & Collectibles': 'Art et collection',
  'Art Objects': "Objets d'art",
  'Art & Photography Books': "Livres d'art et de photographie",
  Ashtrays: 'Cendriers',
  'Baby Blankets': 'Couvertures pour bébé',
  "Baby Boys' Clothing": 'Vêtements bébé garçon',
  Backpacks: 'Sacs à dos',
  'Bags & Purses': 'Sacs et maroquinerie',
  'Baked Goods': 'Boulangerie et pâtisserie',
  Bands: 'Anneaux',
  Bangles: 'Joncs',
  'Bar Soaps': 'Savons solides',
  Barware: 'Accessoires de bar',
  Baskets: 'Paniers',
  'Bath & Beauty': 'Bain et beauté',
  'Bath Mats & Rugs': 'Tapis de bain',
  Bathroom: 'Salle de bain',
  'Bathroom Decor': 'Décoration de salle de bain',
  'Bathroom Vanities': 'Meubles vasques',
  'Bath Salts & Scrubs': 'Sels de bain et gommages',
  'Bath Towels': 'Serviettes de bain',
  'Beach Bags': 'Sacs de plage',
  'Beach Towels': 'Serviettes de plage',
  'Beaded Bracelets': 'Bracelets en perles',
  'Beaded Necklaces': 'Colliers en perles',
  'Bean Bag Chairs': 'Poufs poires',
  Bedding: 'Linge de lit',
  'Bed Frames': 'Cadres de lit',
  'Bed Pillows': 'Oreillers',
  'Bedroom Furniture': 'Meubles de chambre',
  'Beds & Headboards': 'Lits et têtes de lit',
  Bedspreads: 'Couvre-lits',
  'Belly Chains': 'Chaînes de taille',
  Belts: 'Ceintures',
  'Belts & Suspenders': 'Ceintures et bretelles',
  'Benches & Trunks': 'Bancs et malles',
  'Blankets & Throws': 'Couvertures et plaids',
  Blouses: 'Chemisiers',
  'Board Games': 'Jeux de société',
  'Body Jewelry': 'Bijoux de corps',
  'Body Washes & Liquid Soaps': 'Gels douche et savons liquides',
  Books: 'Livres',
  'Books, Movies & Music': 'Livres, films et musique',
  'Booties & Ankle Boots': 'Bottines',
  Boots: 'Bottes',
  Bowls: 'Bols',
  'Boxes & Bins': 'Boîtes et bacs',
  "Boys' Clothing": 'Vêtements garçon',
  Bracelets: 'Bracelets',
  'Bridal Gowns & Separates': 'Robes et tenues de mariée',
  'Bridesmaid Dresses': "Robes de demoiselle d'honneur",
  'Bridesmaid Proposals': "Demandes de demoiselle d'honneur",
  "Bridesmaids' Gifts": "Cadeaux pour demoiselles d'honneur",
  'Briefcases & Attaches': 'Porte-documents et mallettes',
  Brooches: 'Broches',
  'Buffets & China Cabinets': 'Buffets et vaisseliers',
  Candelabras: 'Candélabres',
  Candleholders: 'Bougeoirs',
  'Candle Lanterns': 'Lanternes à bougie',
  Candles: 'Bougies',
  'Candles & Holders': 'Bougies et bougeoirs',
  'Candles & Home Fragrances': "Bougies et parfums d'intérieur",
  'Candlestick Holders': 'Bougeoirs pour chandelles',
  Candy: 'Confiseries',
  'Canes & Walking': 'Cannes et aides à la marche',
  Capes: 'Capes',
  Carafes: 'Carafes',
  'Casserole Dishes': 'Cocottes et plats à four',
  'Ceiling Lights': 'Luminaires de plafond',
  'Chain & Link Bracelets': 'Bracelets chaîne',
  Chains: 'Chaînes',
  'Chair Pads': 'Galettes de chaise',
  Chairs: 'Chaises et fauteuils',
  Chandeliers: 'Lustres',
  'Charm Bracelets': 'Bracelets à breloques',
  'Charm Necklaces': 'Colliers à breloques',
  Checkers: 'Dames',
  'Cheese & Charcuterie Boards': 'Planches à fromage et charcuterie',
  Chess: 'Échecs',
  Chocolates: 'Chocolats',
  'Cigar & Cigarette Accessories': 'Accessoires pour cigares et cigarettes',
  'Cleaning Products': "Produits d'entretien",
  'Cleaning Supplies': "Articles d'entretien",
  'Clip-On Earrings': "Boucles d'oreilles à clip",
  'Clogs & Mules': 'Sabots et mules',
  Clothing: 'Vêtements',
  'Clothing Sets': 'Ensembles',
  'Clutches & Evening Bags': 'Pochettes et sacs de soirée',
  Coasters: 'Sous-verres',
  'Coffee & End Tables': 'Tables basses et bouts de canapé',
  'Coffee Tables': 'Tables basses',
  'Coffee & Tea Makers': 'Cafetières et théières',
  'Coins & Money': 'Pièces et billets',
  'Collectible Plates': 'Assiettes de collection',
  Collectibles: 'Objets de collection',
  'Coloring Books': 'Livres de coloriage',
  'Condiments & Sauces': 'Condiments et sauces',
  'Conditioners & Treatments': 'Après-shampooings et soins',
  'Console Tables & Cabinets': 'Consoles et meubles de rangement',
  'Container Candles': 'Bougies en pot',
  Cookbooks: 'Livres de cuisine',
  Cookies: 'Biscuits',
  'Cooking Utensils & Gadgets': 'Ustensiles de cuisine',
  Cookware: 'Articles de cuisson',
  'Cosmetic Bags': 'Trousses de maquillage',
  'Cosmetic & Toiletry Storage': 'Trousses de toilette et de maquillage',
  'Costume Accessories': 'Accessoires de déguisement',
  Costumes: 'Déguisements',
  'Couches & Loveseats': 'Canapés et causeuses',
  'Cover-Ups': 'Paréos et tuniques de plage',
  'Craft Supplies & Tools': 'Fournitures et outils de création',
  'Crossbody Bags': 'Sacs bandoulière',
  'Cuff Bracelets': 'Manchettes',
  Cups: 'Gobelets',
  'Cutlery & Knives': 'Coutellerie',
  'Dangle & Drop Earrings': "Boucles d'oreilles pendantes",
  'Decals & Skins': 'Stickers et habillages',
  Decorations: 'Décoration',
  'Decorative Baskets': 'Paniers décoratifs',
  'Decorative Bowls': 'Coupes décoratives',
  'Decorative Storage': 'Rangements décoratifs',
  'Decorative Tiles': 'Carreaux décoratifs',
  'Decorative Trays': 'Plateaux décoratifs',
  'Design & Templates': 'Design et modèles',
  'Desk Lamps': 'Lampes de bureau',
  'Dice & Tile Games': 'Jeux de dés et de tuiles',
  Digital: 'Numérique',
  'Digital Prints': 'Impressions numériques',
  'Dining Chairs': 'Chaises de salle à manger',
  'Dining Room Furniture': 'Meubles de salle à manger',
  'Dining & Serving': 'Arts de la table',
  'Dinnerware Sets': 'Services de vaisselle',
  Dominoes: 'Dominos',
  'Door Hangers': 'Décorations de porte',
  'Door Knobs': 'Poignées de porte',
  'Door Mats': 'Paillassons',
  Doors: 'Portes',
  'Doors & Locks': 'Portes et serrures',
  'Drawer Knobs & Pulls': 'Boutons et poignées de meuble',
  'Drawing & Illustration': 'Dessin et illustration',
  'Dressers & Armoires': 'Commodes et armoires',
  Dresses: 'Robes',
  'Dress Shirts': 'Chemises habillées',
  'Drink & Barware': 'Verrerie et bar',
  Drinkware: 'Verres et tasses',
  'Duffel Bags': 'Sacs polochons',
  Earrings: "Boucles d'oreilles",
  'Easter Baskets': 'Paniers de Pâques',
  'Electric Lanterns': 'Lanternes électriques',
  'Electronics & Accessories': 'Électronique et accessoires',
  'Electronics Cases': 'Housses et étuis',
  Embroidery: 'Broderie',
  'Entryway & Mudroom Furniture': "Meubles d'entrée",
  'Espadrilles & Wedges': 'Espadrilles et compensées',
  'Essential Oils': 'Huiles essentielles',
  'Exfoliation & Peels': 'Exfoliants et peelings',
  'Eyelashes & Mascara': 'Cils et mascaras',
  Eyeliners: 'Eye-liners',
  Eyes: 'Yeux',
  Face: 'Teint',
  'Facial Care': 'Soins du visage',
  'Facial Scrubs & Washes': 'Gommages et nettoyants visage',
  'Faucets, Handles & Showerheads': 'Robinetterie et pommeaux de douche',
  'Fiber Arts': 'Arts textiles',
  Figurines: 'Figurines',
  'Figurines & Knick Knacks': 'Figurines et bibelots',
  'Fine Art Ceramics': "Céramique d'art",
  'Floor Lamps': 'Lampadaires',
  'Floor Pillows': 'Coussins de sol',
  'Floor & Rugs': 'Sols et tapis',
  'Food & Drink': 'Alimentation et boissons',
  'Food & Insulated Bags': 'Sacs repas et isothermes',
  Foundations: 'Fonds de teint',
  Fragrances: 'Parfums',
  'Fruit Butters': 'Crèmes de fruits',
  Furniture: 'Meubles',
  'Games & Puzzles': 'Jeux et puzzles',
  'Garden Decoration': 'Décoration de jardin',
  'Gender-Neutral Adult Clothing': 'Vêtements mixtes adulte',
  "Gender-Neutral Kids' Clothing": 'Vêtements mixtes enfant',
  Giclée: 'Tirages giclée',
  'Gift Boxes': 'Boîtes cadeaux',
  'Gifts For The Couple': 'Cadeaux pour les mariés',
  'Gifts & Mementos': 'Cadeaux et souvenirs',
  'Gift Wrapping': 'Emballages cadeaux',
  "Girls' Clothing": 'Vêtements fille',
  "Girls' Shoes": 'Chaussures fille',
  'Gladiator & Strappy Sandals': 'Sandales spartiates et à lanières',
  'Glass Art': 'Art du verre',
  'Glass Sculptures & Figurines': 'Sculptures et figurines en verre',
  'Graphic Design': 'Graphisme',
  'Groomsmen Gifts': "Cadeaux pour garçons d'honneur",
  'Guides & How Tos': 'Guides et tutoriels',
  'Hair Accessories': 'Accessoires pour cheveux',
  'Hair Care': 'Soins capillaires',
  'Hair Jewelry': 'Bijoux de cheveux',
  'Hair Sprays': 'Laques',
  'Hair Styling': 'Produits coiffants',
  Hampers: 'Paniers à linge',
  Handbags: 'Sacs à main',
  'Hangers & Clothing Storage': 'Cintres et rangement des vêtements',
  'Hats & Head Coverings': 'Chapeaux et couvre-chefs',
  Headbands: 'Bandeaux',
  Headboards: 'Têtes de lit',
  'Herbs & Spices': 'Herbes et épices',
  'Herbs, Spices & Seasonings': 'Herbes, épices et assaisonnements',
  Hijabs: 'Hijabs',
  'Hobo Bags': 'Sacs besace',
  'Home Accents': 'Objets décoratifs',
  'Home Appliances': 'Électroménager',
  'Home Decor': "Décoration d'intérieur",
  'Home Fragrances': "Parfums d'intérieur",
  'Home Improvement': 'Bricolage et aménagement',
  'Home & Living': 'Maison',
  Hoodies: 'Sweats à capuche',
  'Hoodies & Sweatshirts': 'Sweats et sweats à capuche',
  'Hooks & Fixtures': 'Crochets et patères',
  'Hoop Earrings': 'Créoles',
  Huaraches: 'Huaraches',
  'Incense Holders': 'Porte-encens',
  'Indoor Fountains': "Fontaines d'intérieur",
  'Indoor Planters': "Cache-pots d'intérieur",
  'Jackets & Coats': 'Vestes et manteaux',
  Jams: 'Confitures',
  'Jars & Containers': 'Bocaux et boîtes',
  Jewelry: 'Bijoux',
  'Jewelry Boxes': 'Boîtes à bijoux',
  'Jewelry Sets': 'Parures',
  'Jewelry Storage': 'Rangements à bijoux',
  'Jigsaw Puzzles': 'Puzzles',
  'Juice Sets & Carafes': 'Services à jus et carafes',
  Keychains: 'Porte-clés',
  'Keychains & Lanyards': 'Porte-clés et tours de cou',
  'Key Holders & Key Hooks': 'Accroche-clés',
  "Kids' Furniture": 'Meubles pour enfants',
  'Kitchen & Dining': 'Cuisine et salle à manger',
  'Kitchen & Dining Tables': 'Tables à manger',
  'Kitchen Storage': 'Rangement de cuisine',
  Knives: 'Couteaux',
  Labels: 'Étiquettes',
  Ladders: 'Échelles',
  'Lamp Harps': "Lyres d'abat-jour",
  Lamps: 'Lampes',
  'Lamp Shades': 'Abat-jour',
  'Lamps, Shades & Bases': 'Lampes, abat-jour et pieds',
  Laptop: 'Ordinateurs portables',
  'Laptop Bags': 'Sacoches pour ordinateur',
  'Laptop Sleeves': 'Housses pour ordinateur',
  'Lariat & Y Necklaces': 'Colliers lariat et en Y',
  'Laundry Bags & Hampers': 'Sacs et paniers à linge',
  'Learning & School': 'Jouets éducatifs',
  'Light Accessories': "Accessoires d'éclairage",
  'Light Fixtures': 'Luminaires',
  Lighting: 'Éclairage',
  'Lighting Parts': 'Pièces pour luminaires',
  'Light Switches': 'Interrupteurs',
  Linens: 'Linge de maison',
  'Lip Balms': 'Baumes à lèvres',
  'Lip Balms & Glosses': 'Baumes et gloss à lèvres',
  'Lip Color': 'Rouges à lèvres',
  'Lip Glosses': 'Gloss',
  Lips: 'Lèvres',
  'Living Room Furniture': 'Meubles de salon',
  Loafers: 'Mocassins',
  'Loafers & Slip Ons': 'Mocassins et chaussures à enfiler',
  Locks: 'Serrures',
  'Logos & Branding': 'Logos et identité visuelle',
  'Luggage & Travel': 'Bagages et voyage',
  'Makeup & Cosmetics': 'Maquillage et cosmétiques',
  'Market Bags': 'Sacs de marché',
  Marmalades: 'Marmelades',
  Meditation: 'Méditation',
  Memorabilia: 'Objets souvenirs',
  "Men's Clothing": 'Vêtements homme',
  "Men's Shoes": 'Chaussures homme',
  "Men's Suits": 'Costumes homme',
  "Men's Wrist Watches": 'Montres homme',
  'Messenger Bags': 'Sacs messager',
  Mirrors: 'Miroirs',
  'Mixed Media & Collage': 'Techniques mixtes et collage',
  Mobiles: 'Mobiles',
  Moccasins: 'Mocassins souples',
  Moisturizers: 'Soins hydratants',
  Mosaics: 'Mosaïques',
  Mugs: 'Mugs',
  'Multi-Stone Rings': 'Bagues multi-pierres',
  Necklaces: 'Colliers',
  Needlepoint: 'Canevas',
  'Night Lights': 'Veilleuses',
  Nightstands: 'Tables de chevet',
  Office: 'Bureau',
  'Office & School Supplies': 'Fournitures de bureau et scolaires',
  Oil: 'Huile',
  'Oil Lamps': 'Lampes à huile',
  'Olive Oil & Vinegar Cruets': 'Huiliers et vinaigriers',
  Ornaments: 'Décorations à suspendre',
  'Ottomans & Poufs': 'Poufs et repose-pieds',
  'Outdoor Fountains': "Fontaines d'extérieur",
  'Outdoor & Gardening': 'Jardin et extérieur',
  'Outdoor Planters': "Jardinières d'extérieur",
  'Overnight Bags': 'Sacs de week-end',
  'Oxfords & Button Downs': 'Chemises Oxford et à col boutonné',
  'Oxfords & Wingtips': 'Richelieus et brogues',
  'Paint & Canvas': 'Peinture sur toile',
  Painting: 'Peinture',
  Pajamas: 'Pyjamas',
  'Pajamas & Robes': 'Pyjamas et peignoirs',
  Paper: 'Papier',
  'Paper & Party Supplies': 'Papeterie et fête',
  'Party Decor': 'Décoration de fête',
  'Party Favors & Games': "Cadeaux d'invités et jeux",
  'Party Games': 'Jeux de fête',
  'Party Lights & Lanterns': 'Guirlandes lumineuses et lanternes',
  'Party Supplies': 'Articles de fête',
  'Patio Furniture': 'Mobilier de jardin',
  'Patio Sets': 'Salons de jardin',
  'Patio Tables': 'Tables de jardin',
  'Pendant Lights': 'Suspensions',
  'Pendant Necklaces': 'Colliers à pendentif',
  'Personal Care': 'Hygiène et soins',
  'Pet Storage': 'Rangement pour animaux',
  'Pet Supplies': 'Accessoires pour animaux',
  'Picnic Baskets & Bags': 'Paniers et sacs de pique-nique',
  Pillowcases: "Taies d'oreiller",
  'Pins & Clips': "Pin's et épingles",
  Placemats: 'Sets de table',
  'Planters & Pots': 'Jardinières et pots',
  Plates: 'Assiettes',
  Platters: 'Plats de service',
  Plumbing: 'Plomberie',
  Polos: 'Polos',
  'Pomades, Waxes & Gels': 'Pommades, cires et gels',
  Ponchos: 'Ponchos',
  'Pot & Pan Sets': 'Batteries de cuisine',
  Pots: 'Marmites',
  'Pots & Pans': 'Casseroles et poêles',
  'Pouches & Coin Purses': 'Pochettes et porte-monnaie',
  'Prayer Beads': 'Chapelets',
  'Prayer Beads & Charms': 'Chapelets et amulettes',
  Preserves: 'Conserves et confitures',
  Prints: 'Tirages',
  'Purse Inserts': 'Organiseurs de sac',
  'Purse Straps': 'Anses et bandoulières',
  Puzzles: 'Puzzles et casse-têtes',
  Quilts: 'Courtepointes',
  'Religious Candles & Incense': 'Bougies et encens religieux',
  Rings: 'Bagues',
  'Ritual Oil & Resins': 'Huiles rituelles et résines',
  Robes: 'Peignoirs',
  'Rocks & Geodes': 'Pierres et géodes',
  Rugmaking: 'Fabrication de tapis',
  Rugs: 'Tapis',
  'Salves & Balms': 'Baumes et onguents',
  Sandals: 'Sandales',
  Scarves: 'Foulards et écharpes',
  'Scarves & Wraps': 'Écharpes et châles',
  Sconces: 'Appliques',
  Sculpture: 'Sculpture',
  'Seasonal Decor': 'Décoration saisonnière',
  'Serving Odds & Ends': 'Accessoires de service',
  Shampoos: 'Shampooings',
  'Shawls & Wraps': 'Châles et étoles',
  'Sheets & Pillowcases': "Draps et taies d'oreiller",
  Shelves: 'Étagères',
  Shelving: 'Rayonnages',
  'Shirts & Tees': 'Chemises et t-shirts',
  Shoes: 'Chaussures',
  'Shoulder Bags': 'Sacs portés épaule',
  Signs: 'Plaques décoratives',
  'Sinks & Basins': 'Éviers et vasques',
  'Skin Care': 'Soins de la peau',
  'Skin Treatment Masks': 'Masques de soin',
  Slipcovers: 'Housses de canapé',
  'Slip Ons': 'Chaussures à enfiler',
  Slippers: 'Chaussons',
  Snacks: 'En-cas',
  'Soap Dishes': 'Porte-savons',
  'Soap Dishes & Dispensers': 'Porte-savons et distributeurs',
  'Soap Dispensers': 'Distributeurs de savon',
  Soaps: 'Savons',
  'Souvenirs & Events': 'Souvenirs et événements',
  'Spa Kits & Gifts': 'Coffrets et cadeaux bien-être',
  'Spa & Relaxation': 'Spa et relaxation',
  'Spirituality & Religion': 'Spiritualité et religion',
  'Sports Bags': 'Sacs de sport',
  'Stackable Rings': 'Bagues empilables',
  'Statement Rings': 'Bagues cocktail',
  Stationery: 'Papeterie',
  'Stickers, Labels & Tags': 'Autocollants et étiquettes',
  'Stools & Banquettes': 'Tabourets et banquettes',
  'Storage & Organization': 'Rangement et organisation',
  Straws: 'Pailles',
  'Study Guides': 'Fiches de révision',
  Suits: 'Costumes',
  Sweaters: 'Pulls',
  Swimwear: 'Maillots de bain',
  'Table Lamps': 'Lampes à poser',
  'Table Linens': 'Linge de table',
  'Table Runners': 'Chemins de table',
  Tableware: 'Vaisselle',
  Tapestries: 'Tapisseries',
  'Tea Cups': 'Tasses à thé',
  'Tea Cups & Sets': 'Tasses et services à thé',
  'Tea Lights': 'Bougies chauffe-plat',
  'Tea Makers': 'Théières et infuseurs',
  Teapots: 'Théières',
  'Tea Sets': 'Services à thé',
  'Throw Pillows': 'Coussins décoratifs',
  Throws: 'Plaids',
  'Tile Games': 'Jeux de tuiles',
  'Tissue Box Covers': 'Housses de boîte à mouchoirs',
  Tobacciana: 'Articles de fumeur',
  'Toilet Paper Holders': 'Dérouleurs de papier toilette',
  'Toothbrush Holders': 'Porte-brosses à dents',
  'Top Handle Bags': 'Sacs à poignée',
  'Tops & Tees': 'Hauts et t-shirts',
  Totes: 'Cabas',
  'Towel Racks & Rods': 'Porte-serviettes',
  Toys: 'Jouets',
  'Toys & Games': 'Jouets et jeux',
  'Toy Storage': 'Rangements pour jouets',
  Trays: 'Plateaux',
  'Trays & Platters': 'Plateaux et plats de service',
  'T-shirts': 'T-shirts',
  'Tumblers & Water Glasses': 'Verres à eau et gobelets',
  Tunics: 'Tuniques',
  Vases: 'Vases',
  Vessels: 'Récipients',
  Vests: 'Gilets',
  'Wall Decals & Murals': 'Stickers muraux et fresques',
  'Wall Decor': 'Décoration murale',
  Wallets: 'Portefeuilles',
  'Wallets & Money Clips': 'Portefeuilles et pinces à billets',
  'Wall Hangings': 'Tentures murales',
  'Wall Lights': 'Luminaires muraux',
  Watches: 'Montres',
  'Water Bottles': 'Gourdes',
  'Wedding Favors': "Cadeaux d'invités de mariage",
  Weddings: 'Mariage',
  'Weighted Blankets': 'Couvertures lestées',
  "Women's Clothing": 'Vêtements femme',
  "Women's Shoes": 'Chaussures femme',
  "Women's Wrist Watches": 'Montres femme',
  'Woven Baskets': 'Paniers tressés',
  'Wreaths & Door Hangers': 'Couronnes et décorations de porte',
  'Wrist Watches': 'Montres-bracelets',
};
